import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';

const STATIONS = [
  // ── 🔴 Live Radio (North America) ────────────────────────────────────────
  { id: 'kiisfm',        name: 'KIIS FM 102.7 LA',   url: 'https://stream.revma.ihrhls.com/zc2169',                                           genre: 'Top 40 / Pop',         category: 'Live Radio' },
  { id: 'z100',          name: 'Z100 New York',       url: 'https://stream.revma.ihrhls.com/zc1313',                                           genre: 'Top 40 / Pop Hits',    category: 'Live Radio' },
  { id: 'hot97',         name: 'Hot 97 New York',     url: 'https://playerservices.streamtheworld.com/api/livestream-redirect/WQHTAAC.aac',    genre: 'Hip-Hop & R&B',        category: 'Live Radio' },
  { id: 'power1051',     name: 'Hip Hop Nation',      url: 'https://stream.laut.fm/hiphop',                                                    genre: 'Hip-Hop / Rap',        category: 'Live Radio' },
  { id: 'power106',      name: 'Power 106 LA',        url: 'https://playerservices.streamtheworld.com/api/livestream-redirect/KPWRAAC.aac',    genre: 'Hip-Hop / Rap',        category: 'Live Radio' },
  { id: 'kiss-chicago',  name: 'Soul Classics',       url: 'https://stream.laut.fm/soul',                                                      genre: 'Soul / R&B',           category: 'Live Radio' },
  { id: 'kexp',          name: 'KEXP 90.3 Seattle',   url: 'https://kexp-mp3-128.streamguys1.com/kexp128.mp3',                                 genre: 'Indie / All Genre',    category: 'Live Radio' },
  { id: 'radio-paradise',name: 'Radio Paradise',      url: 'https://stream.radioparadise.com/mp3-128',                                          genre: 'Rock / Alt / Eclectic',category: 'Live Radio' },
  { id: 'kcrw',          name: 'Jazz FM Live',        url: 'https://stream.laut.fm/jazz',                                                      genre: 'Jazz & Standards',     category: 'Live Radio' },
  { id: 'wfmu',          name: 'WFMU New Jersey',     url: 'https://stream0.wfmu.org/freeform-128k',                                           genre: 'Freeform / Eclectic',  category: 'Live Radio' },
  { id: 'ckua',          name: 'Funk Street',         url: 'https://stream.laut.fm/funk',                                                      genre: 'Funk & Groove',        category: 'Live Radio' },
  // ── Hip Hop ──────────────────────────────────────────────────────────────
  { id: 'rap-hub',       name: 'Rap Hub',           url: 'https://stream.zeno.fm/f3wvbbqmdg8uv',             genre: 'Rap & Trap',           category: 'Hip Hop' },
  { id: 'the-beat',      name: 'The Beat',           url: 'https://stream.zeno.fm/wp604zw8m0quv',             genre: 'Hip Hop & R&B',        category: 'Hip Hop' },
  { id: 'old-school',    name: 'Old School Rap',     url: 'https://stream.zeno.fm/rp1swb5pgzzuv',             genre: '90s & 2000s Classics', category: 'Hip Hop' },
  { id: 'wefunk',        name: 'WeFunk Radio',       url: 'https://funk.stream.laut.fm/funk',                 genre: 'Funk & Soul',          category: 'Hip Hop' },
  { id: 'lofi-hiphop',   name: 'Lofi Hip Hop',       url: 'https://stream.zeno.fm/0r0xa792kwzuv',             genre: 'Chill Beats',          category: 'Hip Hop' },
  { id: 'bagel',         name: 'BAGeL Radio',        url: 'https://ice1.somafm.com/bagel-128-mp3',            genre: 'Hip Hop / Alt',        category: 'Hip Hop' },
  // ── Electronic ───────────────────────────────────────────────────────────
  { id: 'groove-salad',  name: 'Groove Salad',       url: 'https://ice1.somafm.com/groovesalad-128-mp3',      genre: 'Electronic Chill',     category: 'Electronic' },
  { id: 'cliqhop',       name: 'CliqHop IDM',        url: 'https://ice1.somafm.com/cliqhop-128-mp3',          genre: 'IDM / Glitch',         category: 'Electronic' },
  { id: 'beat-blender',  name: 'Beat Blender',       url: 'https://ice1.somafm.com/beatblender-128-mp3',      genre: 'Deep House / Techno',  category: 'Electronic' },
  { id: 'digitalis',     name: 'Digitalis',          url: 'https://ice1.somafm.com/digitalis-128-mp3',        genre: 'Indie Electronic',     category: 'Electronic' },
  { id: 'poptron',       name: 'PopTron',            url: 'https://ice1.somafm.com/poptron-128-mp3',          genre: 'Electronic Pop',       category: 'Electronic' },
  { id: 'techno',        name: 'Techno Radio',       url: 'https://radcap.ru/techno.mp3',                     genre: 'Techno',               category: 'Electronic' },
  { id: 'house',         name: 'House Radio',        url: 'https://radcap.ru/house.mp3',                      genre: 'House',                category: 'Electronic' },
  { id: 'the-trip',      name: 'The Trip',           url: 'https://ice1.somafm.com/thetrip-128-mp3',          genre: 'Psychedelic / Dark',   category: 'Electronic' },
  { id: 'fluid',         name: 'Fluid',              url: 'https://ice1.somafm.com/fluid-128-mp3',            genre: 'Psychedelic Blends',   category: 'Electronic' },
  { id: 'synthwave',     name: 'Synthwave FM',        url: 'https://stream.laut.fm/synthwave',                 genre: 'Synthwave / Retrowave',category: 'Electronic' },
  // ── Rock ─────────────────────────────────────────────────────────────────
  { id: 'indie-pop',     name: 'Indie Pop Rocks',    url: 'https://ice1.somafm.com/indiepop-128-mp3',         genre: 'Indie Pop',            category: 'Rock' },
  { id: 'lush',          name: 'Lush',               url: 'https://ice1.somafm.com/lush-128-mp3',             genre: 'Dream Pop / Shoegaze', category: 'Rock' },
  { id: 'alt-rock',      name: 'Alternative Rock',   url: 'https://radcap.ru/alternativerock.mp3',            genre: 'Alt Rock',             category: 'Rock' },
  { id: 'classic-rock',  name: 'Classic Rock',       url: 'https://radcap.ru/classicrock.mp3',                genre: 'Classic Rock',         category: 'Rock' },
  { id: 'metal',         name: 'Metal Detector',     url: 'https://ice1.somafm.com/metal-128-mp3',            genre: 'Heavy Metal',          category: 'Rock' },
  { id: 'covers',        name: 'Cover to Cover',     url: 'https://ice1.somafm.com/covers-128-mp3',           genre: 'All-Genre Covers',     category: 'Rock' },
  // ── Pop & R&B ─────────────────────────────────────────────────────────────
  { id: 'top40',         name: 'Top 40 Hits',        url: 'https://radcap.ru/top40.mp3',                      genre: "Today's Top Hits",     category: 'Pop & R&B' },
  { id: 'dance',         name: 'Dance Pop',          url: 'https://radcap.ru/dance.mp3',                      genre: 'Dance / Pop',          category: 'Pop & R&B' },
  { id: 'seventies',     name: '70s Hits',           url: 'https://ice1.somafm.com/seventies-128-mp3',        genre: '70s Classic',          category: 'Pop & R&B' },
  { id: 'u80s',          name: '80s Hits',           url: 'https://ice1.somafm.com/u80s-128-mp3',             genre: '80s Rewind',           category: 'Pop & R&B' },
  { id: 'illstreet',     name: 'Illinois Street',    url: 'https://ice1.somafm.com/illstreet-128-mp3',        genre: '50s-60s Lounge',       category: 'Pop & R&B' },
  // ── Jazz & Soul ──────────────────────────────────────────────────────────
  { id: 'jazz',          name: 'Jazz Radio',         url: 'https://radcap.ru/jazz.mp3',                       genre: 'Jazz',                 category: 'Jazz & Soul' },
  { id: 'smooth-jazz',   name: 'Smooth Jazz',        url: 'https://radcap.ru/smooth-jazz.mp3',                genre: 'Smooth Jazz',          category: 'Jazz & Soul' },
  { id: 'sonic-univ',    name: 'Sonic Universe',     url: 'https://ice1.somafm.com/sonicuniverse-128-mp3',    genre: 'Jazz Fusion',          category: 'Jazz & Soul' },
  { id: 'nola-jazz',     name: 'New Orleans Jazz',   url: 'https://stream.laut.fm/jazz',                          genre: 'Jazz & Standards',     category: 'Jazz & Soul' },
  { id: 'scanner',       name: 'Scanner',            url: 'https://ice1.somafm.com/scanner-128-mp3',          genre: 'Jazz / Blues / World', category: 'Jazz & Soul' },
  // ── World ─────────────────────────────────────────────────────────────────
  { id: 'reggae',        name: 'Reggae',             url: 'https://ice1.somafm.com/reggae-128-mp3',           genre: 'Reggae',               category: 'World' },
  { id: 'salsa',         name: 'Salsa / Latin',      url: 'https://radcap.ru/salsa.mp3',                      genre: 'Latin',                category: 'World' },
  { id: 'country',       name: 'Boot Liquor',        url: 'https://ice1.somafm.com/bootliquor-128-mp3',       genre: 'Country / Americana',  category: 'World' },
  { id: 'folk',          name: 'Folk Forward',       url: 'https://ice1.somafm.com/folkfwd-128-mp3',          genre: 'Folk',                 category: 'World' },
  { id: 'secret-agent',  name: 'Secret Agent',       url: 'https://ice1.somafm.com/secretagent-128-mp3',      genre: 'Lounge / Spy Jazz',    category: 'World' },
  { id: 'thistle',       name: 'Thistle Radio',      url: 'https://ice1.somafm.com/thistle-128-mp3',          genre: 'Scottish / Celtic',    category: 'World' },
  { id: 'suburbs-goa',   name: 'Suburbs of Goa',     url: 'https://ice1.somafm.com/suburbsofgoa-128-mp3',     genre: 'Indian Electronic',    category: 'World' },
  // ── Ambient & Focus ──────────────────────────────────────────────────────
  { id: 'synphaera',     name: 'Synphaera',          url: 'https://ice1.somafm.com/synphaera-128-mp3',        genre: 'Space Ambient',        category: 'Ambient' },
  { id: 'drone-zone',    name: 'Drone Zone',         url: 'https://ice1.somafm.com/dronezone-128-mp3',        genre: 'Deep Ambient',         category: 'Ambient' },
  { id: 'deep-space',    name: 'Deep Space One',     url: 'https://ice1.somafm.com/deepspaceone-128-mp3',     genre: 'Space Music',          category: 'Ambient' },
  { id: 'lofi-beats',    name: 'Lofi Beats',         url: 'https://stream.zeno.fm/hqbrk7skwxhvv',            genre: 'Instrumentals',        category: 'Ambient' },
  { id: 'mission-ctrl',  name: 'Mission Control',    url: 'https://ice1.somafm.com/missioncontrol-128-mp3',   genre: 'Focus / Concentration',category: 'Ambient' },
  { id: 'classical',     name: 'Classical Radio',    url: 'https://radcap.ru/classical.mp3',                  genre: 'Orchestra / Classical',category: 'Ambient' },
];

const CATEGORY_EMOJIS = {
  'Live Radio': '🔴',
  'Hip Hop':    '🎤',
  'Electronic': '🎛️',
  'Rock':       '🎸',
  'Pop & R&B':  '🎵',
  'Jazz & Soul':'🎷',
  'World':      '🌍',
  'Ambient':    '🌙',
};

const LOCAL_STORAGE_KEY  = 'qg_radio_station';
const HAS_PICKED_KEY     = 'qg_radio_picked';
const DEFAULT_STATION_ID = 'rap-hub';
const DEFAULT_VOLUME     = 0.2;

function getDefaultStation() {
  return STATIONS.find(s => s.id === DEFAULT_STATION_ID) || STATIONS[0];
}
function getSavedStationLocal() {
  try {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) return STATIONS.find(s => s.id === saved) || getDefaultStation();
  } catch {}
  return getDefaultStation();
}
function getHasPicked() {
  try { return localStorage.getItem(HAS_PICKED_KEY) === '1'; } catch { return false; }
}

// ── Singleton audio store ─────────────────────────────────────────────────
// One Audio object shared across ALL RadioPlayer instances so only one stream
// ever plays at a time, regardless of how many components are mounted.
let _audio = null;
let _storeState = {
  playing: false,
  loading: false,
  error:   false,
  volume:  DEFAULT_VOLUME,
  station: getSavedStationLocal(),
};
const _listeners = new Set();

function getAudio() {
  if (!_audio) {
    _audio = new Audio();
    _audio.preload = 'none';
    _audio.volume  = _storeState.volume;
    _audio.addEventListener('waiting', () => _notify({ loading: true }));
    _audio.addEventListener('playing', () => _notify({ loading: false, playing: true, error: false }));
    _audio.addEventListener('pause',   () => _notify({ playing: false }));
    _audio.addEventListener('error',   () => _notify({ loading: false, playing: false, error: true }));
  }
  return _audio;
}

function _notify(patch) {
  _storeState = { ..._storeState, ...patch };
  _listeners.forEach(fn => fn({ ..._storeState }));
}

function radioSubscribe(fn) {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}

function radioLoad(station, autoplay = true) {
  const audio = getAudio();
  _notify({ loading: true, playing: false, error: false, station });
  audio.pause();
  audio.src = station.url;
  audio.load();
  if (autoplay) {
    audio.play().catch(() => _notify({ loading: false, playing: false }));
  } else {
    _notify({ loading: false });
  }
}

function radioTogglePlay() {
  const audio = getAudio();
  if (audio.paused) {
    _notify({ loading: true });
    audio.play().catch(() => _notify({ loading: false }));
  } else {
    audio.pause();
  }
}

function radioSetVolume(v) {
  const audio = getAudio();
  audio.volume = v;
  _notify({ volume: v });
}

// Pause/resume hooks for call integration
window.addEventListener('radio:pause', () => {
  const audio = getAudio();
  if (!audio.paused) {
    audio._wasPlaying = true;
    audio.pause();
  }
});
window.addEventListener('radio:resume', () => {
  const audio = getAudio();
  if (audio._wasPlaying) {
    audio._wasPlaying = false;
    audio.play().catch(() => {});
  }
});
// ── Autoplay on page load ─────────────────────────────────────────────────
// Browsers block audio until a user gesture. Strategy:
//  1. Attempt play() immediately (works if the browser permits it).
//  2. If blocked, attach a one-time listener for the first interaction
//     (click / touchstart / keydown / scroll) and play then.
let _autoplayScheduled = false;

function _scheduleAutoplay() {
  if (_autoplayScheduled) return;
  _autoplayScheduled = true;

  const station = _storeState.station;

  // Attempt 2 — on first user gesture (fallback if autoplay is blocked)
  const tryOnInteraction = () => {
    INTERACTION_EVENTS.forEach(ev => document.removeEventListener(ev, tryOnInteraction, { capture: true }));
    if (!_storeState.playing && !_storeState.loading) {
      radioLoad(_storeState.station, true);
    }
  };

  const INTERACTION_EVENTS = ['click', 'touchstart', 'keydown', 'scroll'];

  // Try immediately; if it fails (autoplay blocked), wait for a gesture
  const audio = getAudio();
  audio.src = station.url;
  audio.load();
  _notify({ loading: true, playing: false, error: false, station });
  audio.play().then(() => {
    // Success — browser allowed autoplay
  }).catch(() => {
    _notify({ loading: false, playing: false });
    INTERACTION_EVENTS.forEach(ev =>
      document.addEventListener(ev, tryOnInteraction, { once: false, capture: true, passive: true })
    );
  });
}

const _IS_SHOWCASE = typeof window !== 'undefined' && window.location.pathname.startsWith('/showcase/');

if (typeof window !== 'undefined' && !_IS_SHOWCASE) {
  if (document.readyState === 'complete') {
    _scheduleAutoplay();
  } else {
    window.addEventListener('load', _scheduleAutoplay, { once: true });
  }
}
// ─────────────────────────────────────────────────────────────────────────

export default function RadioPlayer() {
  const { user } = useAuth();
  const dropRef  = useRef(null);
  const listRef  = useRef(null);

  const [radioState, setRadioState] = useState(() => ({ ..._storeState }));
  const { playing, loading, error, volume, station } = radioState;

  const [showDrop,  setShowDrop]  = useState(false);
  const [showVol,   setShowVol]   = useState(false);
  const [search,    setSearch]    = useState('');
  const [defaultId, setDefaultId] = useState(null);
  const [savingId,  setSavingId]  = useState(null);
  const [hasPicked, setHasPicked] = useState(getHasPicked);

  // Subscribe to the singleton store
  useEffect(() => {
    return radioSubscribe(s => setRadioState({ ...s }));
  }, []);

  // Load user's saved default from Supabase
  useEffect(() => {
    if (!user?.id) return;
    supabase
      .from('profiles')
      .select('default_radio_station')
      .eq('id', user.id)
      .single()
      .then(({ data }) => {
        if (data?.default_radio_station) {
          setDefaultId(data.default_radio_station);
          const found = STATIONS.find(s => s.id === data.default_radio_station);
          if (found) {
            setHasPicked(true);
            try {
              localStorage.setItem(LOCAL_STORAGE_KEY, found.id);
              localStorage.setItem(HAS_PICKED_KEY, '1');
            } catch {}
            _notify({ station: found });
          }
        }
      })
      .catch(() => {});
  }, [user?.id]);

  // Scroll station list to active station when dropdown opens
  useEffect(() => {
    if (!showDrop || !hasPicked || !listRef.current) return;
    const t = setTimeout(() => {
      const el = listRef.current?.querySelector(`[data-station-id="${station.id}"]`);
      if (el) el.scrollIntoView({ block: 'center', behavior: 'instant' });
    }, 30);
    return () => clearTimeout(t);
  }, [showDrop, hasPicked, station.id]);

  // Close dropdowns on outside click
  useEffect(() => {
    function onClickOut(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setShowDrop(false);
        setShowVol(false);
      }
    }
    document.addEventListener('mousedown', onClickOut);
    return () => document.removeEventListener('mousedown', onClickOut);
  }, []);

  const pickStation = useCallback((s) => {
    setHasPicked(true);
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, s.id);
      localStorage.setItem(HAS_PICKED_KEY, '1');
    } catch {}
    setShowDrop(false);
    setSearch('');
    radioLoad(s, true);
  }, []);

  const saveAsDefault = async (e, s) => {
    e.stopPropagation();
    if (!user?.id) return;
    setSavingId(s.id);
    try {
      await supabase
        .from('profiles')
        .update({ default_radio_station: s.id })
        .eq('id', user.id);
      setDefaultId(s.id);
    } catch {}
    setSavingId(null);
  };

  const prevStation = () => {
    const filtered = search
      ? STATIONS.filter(s => s.name.toLowerCase().includes(search.toLowerCase()) || s.genre.toLowerCase().includes(search.toLowerCase()))
      : STATIONS;
    const idx  = filtered.findIndex(s => s.id === station.id);
    pickStation(filtered[(idx - 1 + filtered.length) % filtered.length]);
  };

  const nextStation = () => {
    const filtered = search
      ? STATIONS.filter(s => s.name.toLowerCase().includes(search.toLowerCase()) || s.genre.toLowerCase().includes(search.toLowerCase()))
      : STATIONS;
    const idx  = filtered.findIndex(s => s.id === station.id);
    pickStation(filtered[(idx + 1) % filtered.length]);
  };

  const volPct = Math.round(volume * 100);

  const filteredStations = search
    ? STATIONS.filter(s =>
        s.name.toLowerCase().includes(search.toLowerCase()) ||
        s.genre.toLowerCase().includes(search.toLowerCase()) ||
        s.category.toLowerCase().includes(search.toLowerCase())
      )
    : STATIONS;

  const categories = [];
  const seen = new Set();
  filteredStations.forEach(s => {
    if (!seen.has(s.category)) { seen.add(s.category); categories.push(s.category); }
  });

  return (
    <div className="flex items-center gap-1" ref={dropRef}>

      {/* Station name / dropdown trigger */}
      <button
        onClick={() => { setShowDrop(d => !d); setShowVol(false); }}
        title="Choose station"
        className={`hidden sm:flex items-center gap-1.5 h-8 px-2.5 rounded-lg border transition-colors text-xs font-medium max-w-[130px] ${error ? 'bg-red-500/10 border-red-500/30 text-red-400 hover:bg-red-500/15' : 'bg-white/5 hover:bg-white/10 border-white/10 text-secondary hover:text-primary'}`}
      >
        {playing && !loading ? (
          <span className="flex gap-px items-end h-3 flex-shrink-0">
            {[1, 2, 3].map(i => (
              <span key={i} className="w-[3px] rounded-sm bg-yellow-400"
                style={{ height: '100%', animation: `barBounce${i} .8s ease-in-out infinite`, animationDelay: `${i * .15}s` }} />
            ))}
          </span>
        ) : loading ? (
          <span className="w-3 h-3 rounded-full border-2 border-yellow-400 border-t-transparent animate-spin flex-shrink-0" />
        ) : (
          <svg className="w-3 h-3 flex-shrink-0 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
          </svg>
        )}
        <span className="truncate">{station.name}</span>
        <svg className="w-2.5 h-2.5 flex-shrink-0 text-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Prev */}
      <button onClick={prevStation} title="Previous station"
        className="w-7 h-7 flex items-center justify-center rounded-lg text-muted hover:text-primary hover:bg-white/8 transition-colors flex-shrink-0">
        <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M6 6h2v12H6zm3.5 6 8.5 6V6z" />
        </svg>
      </button>

      {/* Play/Pause */}
      <button onClick={radioTogglePlay} title={playing ? 'Pause' : 'Play'}
        className={`w-7 h-7 flex items-center justify-center rounded-lg transition-colors flex-shrink-0 ${playing ? 'text-yellow-400 hover:text-yellow-300 bg-yellow-500/10 hover:bg-yellow-500/15' : 'text-muted hover:text-primary hover:bg-white/8'}`}>
        {loading ? (
          <span className="w-3.5 h-3.5 rounded-full border-2 border-yellow-400 border-t-transparent animate-spin" />
        ) : playing ? (
          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19h4V5H6zm8-14v14h4V5z" />
          </svg>
        ) : (
          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
        )}
      </button>

      {/* Next */}
      <button onClick={nextStation} title="Next station"
        className="w-7 h-7 flex items-center justify-center rounded-lg text-muted hover:text-primary hover:bg-white/8 transition-colors flex-shrink-0">
        <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M6 18l8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z" />
        </svg>
      </button>

      {/* Volume */}
      <button onClick={() => { setShowVol(v => !v); setShowDrop(false); }} title={`Volume: ${volPct}%`}
        className="hidden sm:flex w-7 h-7 items-center justify-center rounded-lg text-muted hover:text-primary hover:bg-white/8 transition-colors flex-shrink-0">
        {volume === 0 ? (
          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" />
          </svg>
        ) : volume < 0.5 ? (
          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z" />
          </svg>
        ) : (
          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
          </svg>
        )}
      </button>

      {/* Dropdowns anchor */}
      <div className="relative">
        {/* Volume slider */}
        {showVol && (
          <div className="absolute right-0 top-9 z-50 bg-card border border-theme rounded-xl shadow-xl p-3 w-36">
            <p className="text-[10px] font-semibold text-muted uppercase tracking-wide mb-2">Volume — {volPct}%</p>
            <input
              type="range" min="0" max="1" step="0.01" value={volume}
              onChange={e => radioSetVolume(parseFloat(e.target.value))}
              className="w-full h-1.5 accent-yellow-400 cursor-pointer"
            />
            <div className="flex justify-between mt-1">
              <span className="text-[9px] text-muted">0%</span>
              <span className="text-[9px] text-muted">100%</span>
            </div>
          </div>
        )}

        {/* Station picker */}
        {showDrop && (
          <div className="absolute right-0 top-9 z-50 bg-card border border-theme rounded-xl shadow-xl overflow-hidden w-72">
            {/* Header */}
            <div className="px-3 py-2 border-b border-theme flex items-center gap-2">
              <p className="text-[10px] font-black uppercase tracking-wide text-yellow-400 flex-1">🎵 Radio Stations</p>
              <span className="text-[9px] text-muted">{STATIONS.length} stations</span>
            </div>

            {/* Search */}
            <div className="px-2 py-1.5 border-b border-theme/50">
              <div className="flex items-center gap-1.5 bg-white/5 rounded-lg px-2 py-1">
                <svg className="w-3 h-3 text-muted flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  placeholder="Search stations..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  className="bg-transparent text-xs text-primary placeholder-muted outline-none flex-1 min-w-0"
                  autoFocus
                />
                {search && (
                  <button onClick={() => setSearch('')} className="text-muted hover:text-primary">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    </svg>
                  </button>
                )}
              </div>
            </div>

            {/* Logged-in default tip */}
            {user && (
              <div className="px-3 py-1 bg-yellow-500/5 border-b border-theme/30">
                <p className="text-[9px] text-yellow-400/70">⭐ Star a station to set it as your default</p>
              </div>
            )}

            {/* Station list */}
            <div ref={listRef} className="max-h-80 overflow-y-auto">
              {categories.length === 0 ? (
                <div className="px-3 py-6 text-center">
                  <p className="text-xs text-muted">No stations found</p>
                </div>
              ) : categories.map(cat => (
                <div key={cat}>
                  <div className="px-3 py-1.5 bg-white/3 border-b border-theme/50 sticky top-0">
                    <p className="text-[9px] font-black uppercase tracking-widest text-muted">
                      {CATEGORY_EMOJIS[cat]} {cat}
                    </p>
                  </div>
                  {filteredStations.filter(s => s.category === cat).map(s => (
                    <button
                      key={s.id}
                      data-station-id={s.id}
                      onClick={() => pickStation(s)}
                      className={`w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors hover:bg-white/5 group ${station.id === s.id ? 'bg-yellow-500/8' : ''}`}
                    >
                      {station.id === s.id && playing ? (
                        <span className="flex gap-px items-end h-3 flex-shrink-0">
                          {[1,2,3].map(i => (
                            <span key={i} className="w-[3px] rounded-sm bg-yellow-400"
                              style={{ height: '100%', animation: `barBounce${i} .8s ease-in-out infinite`, animationDelay: `${i * .15}s` }} />
                          ))}
                        </span>
                      ) : (
                        <svg className={`w-3 h-3 flex-shrink-0 ${station.id === s.id ? 'text-yellow-400' : 'text-muted'}`} fill="currentColor" viewBox="0 0 20 20">
                          <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
                        </svg>
                      )}

                      <div className="min-w-0 flex-1">
                        <p className={`text-xs font-semibold truncate ${station.id === s.id ? 'text-yellow-400' : 'text-primary'}`}>{s.name}</p>
                        <p className="text-[10px] text-muted">{s.genre}</p>
                      </div>

                      <div className="flex items-center gap-1 flex-shrink-0">
                        {user && (
                          <button
                            onClick={(e) => saveAsDefault(e, s)}
                            title={defaultId === s.id ? 'Your default station' : 'Set as default'}
                            className={`w-5 h-5 flex items-center justify-center rounded transition-all ${defaultId === s.id ? 'text-yellow-400' : 'text-transparent group-hover:text-muted/40 hover:!text-yellow-400'}`}
                          >
                            {savingId === s.id ? (
                              <span className="w-2.5 h-2.5 rounded-full border border-yellow-400 border-t-transparent animate-spin" />
                            ) : (
                              <svg className="w-3 h-3" fill={defaultId === s.id ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                              </svg>
                            )}
                          </button>
                        )}

                        {station.id === s.id && (
                          <span className="text-[9px] font-black text-yellow-400 bg-yellow-500/10 px-1.5 py-0.5 rounded">ON</span>
                        )}
                      </div>
                    </button>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
